// extracted by mini-css-extract-plugin
module.exports = {"room-link":"_7a3fb80146--room-link--R6fnW","link":"_7a3fb80146--link--Rxk7T"};